import { FC } from "react";
import { IViewpointEngine } from 'Services/viewpoint/IViewpointEngine';
import { ConfigProvider } from "antd";
import { ICustomOption } from "Pages/Activities/Modals/ShowCreateActivity/useOptionsSelect";
import { IStage } from "Data/interfaces/Obra/IObraStages";
import { IUserInforResponse } from "Data/interfaces/Auth/IUserInfoResponse";
import { IDisciplineResponse } from "Data/interfaces/Obra/IDisciplineResponse";
import useCreateActivityWithViewpoint from "./useCreateActivityWithViewpoint";
import FormContent from "Pages/Activities/Modals/ShowCreateActivity/components/FormContent";
import SnapshotPreview from "./components/SnapshotPreview";
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import { Icon } from "Components/UI";
import {
  Wrapper,
  Content,
  LeftContent,
  RightContent,
  VerticalHr,
  FooterHr,
  ButtonsWrapper,
} from "./styles";

interface ICreateActivityWithViewpoint {
  visible: boolean;
  csId: number;
  /** Motor que captura o viewpoint — Autodesk ou ifc-lite. */
  engine: IViewpointEngine | null;
  visibilityOptions: ICustomOption[];
  priorityOptions: ICustomOption[];
  priorityNoBgOptions: ICustomOption[];
  typeOptions: ICustomOption[];
  stageOptions: string[];
  pointsOptions: string[];
  communicationOptions: string[];
  userOptions: ICustomOption[];
  disciplineOptions: ICustomOption[];
  disciplines?: IDisciplineResponse[];
  stages: IStage[];
  allowOnlyStagesLinkedToDisciplinesInTopics: boolean;
  createStageLoading: boolean;
  userInfo?: IUserInforResponse;
  onCancel: () => void;
  onCreateStage?: (stageName: string, disciplinesFk: number[]) => void;
}

const CreateActivityWithViewpoint: FC<ICreateActivityWithViewpoint> = ({
  visible,
  csId,
  engine,
  visibilityOptions,
  priorityOptions,
  priorityNoBgOptions,
  typeOptions,
  stageOptions,
  pointsOptions,
  communicationOptions,
  userOptions,
  disciplineOptions,
  disciplines,
  stages,
  allowOnlyStagesLinkedToDisciplinesInTopics,
  createStageLoading,
  userInfo,
  onCancel,
  onCreateStage,
}) => {
  const {
    loading,
    capturingViewpoint,
    snapshotUrl,
    isSubmit,
    titleValue,
    selectedDisciplines,
    errors,
    defaultValues,
    handleTitleValue,
    handleSelectedDisciplines,
    handleCustomError,
    handleClearCustomError,
    handleIsSubmit,
    submit,
  } = useCreateActivityWithViewpoint({
    visible,
    csId,
    engine,
    typeOptions,
    stages,
    allowOnlyStagesLinkedToDisciplinesInTopics,
    onClose: onCancel,
  });

  const footerButtons = (
    <ButtonsWrapper>
      <Button
        onClick={onCancel}
        type="text"
        className="buttonCancel"
        disabled={loading}
      >
        Cancelar
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        onClick={() => handleIsSubmit(true)}
        className="buttonSubmit"
        disabled={loading || capturingViewpoint}
        loading={loading}
      >
        Cadastrar
      </Button>
    </ButtonsWrapper>
  );

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footerButtons={footerButtons}
      footerActive={false}
      width={874}
      customClassName
    >
      <ConfigProvider>
        <Wrapper>
          <div className="header">
            <span className="titleHeader">Nova Atividade do Visualizador</span>
            <span className="iconHeader">
              <Icon
                icon="cancelar"
                customSize={8}
                customColor="#324150"
                onClick={onCancel}
              />
            </span>
          </div>

          <Content>
            <LeftContent>
              <FormContent
                updateActivity={null}
                visibilityOptions={visibilityOptions}
                priorityOptions={priorityOptions}
                priorityNoBgOptions={priorityNoBgOptions}
                statusOptions={[]} // Not needed for creation
                typeOptions={typeOptions}
                stageOptions={stageOptions}
                pointsOptions={pointsOptions}
                communicationOptions={communicationOptions}
                userOptions={userOptions}
                disciplineOptions={disciplineOptions}
                stages={stages}
                allowOnlyStagesLinkedToDisciplinesInTopics={allowOnlyStagesLinkedToDisciplinesInTopics}
                userInfo={userInfo}
                isSubmit={isSubmit}
                titleValue={titleValue}
                defaultValues={defaultValues}
                errors={errors as any}
                selectedDisciplines={selectedDisciplines}
                handleTitleValue={handleTitleValue}
                submit={submit as any}
                dynamicUpdateSubmit={() => {}} // Not needed for creation
                handleClearCustomError={handleClearCustomError as any}
                handleCustomError={handleCustomError as any}
                onShowCreateStageModal={() => {}} // TODO: Implement if needed
                onSelectedDisciplines={handleSelectedDisciplines}
              />
            </LeftContent>

            <VerticalHr />

            <RightContent>
              <SnapshotPreview
                snapshotUrl={snapshotUrl}
                loading={capturingViewpoint}
              />
            </RightContent>
          </Content>
        </Wrapper>

        <FooterHr />
      </ConfigProvider>
    </Modal>
  );
};

export default CreateActivityWithViewpoint;
